import React from 'react';
import { SaveToProjects } from 'components/icons';
import { BLACK_COLOR_HEX, SAVE_TO_PROJECTS, WHITE_COLOR_HEX } from 'helpers/constants';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, mobile, tablet } from 'helpers/utils/screensizes';
import { cleanString } from 'helpers/utils/util';
import Link from '../../atoms/link';
export interface Props {
  expiresInOrStatus?: string;
  themeColor?: string;
  keyProp?: string;
  ffidCurated?: string;
}
const SaveToProjectsComponent: React.FC<Props> = ({ expiresInOrStatus, themeColor, ffidCurated, keyProp }) => {
  const [, width] = useMediaQuery(mobile);
  const [isDesktopSize] = useMediaQuery(desktop);
  const isPureMobile = width < tablet;
  const elmentStyles = isDesktopSize ? { border: `1px solid ${WHITE_COLOR_HEX}` } : { border: `1px solid ${BLACK_COLOR_HEX}` };
  const textStyles = 'text-secondary';
  return (
    <Link data-ffid={`lnk-${cleanString(ffidCurated ?? '')}-save-${keyProp}`}>
      <div
        className={`save-to-project ${themeColor === 'dark' && isPureMobile ? 'bg-transparent' : 'bg-white'} text-[${BLACK_COLOR_HEX}] flex w-fit items-center rounded-full px-16 py-4 lg:px-6 ${isDesktopSize && 'absolute right-12 top-12'}`}
        style={elmentStyles}
      >
        <SaveToProjects className={`w-24 text-primary ${textStyles} mr-3`} />
        <span
          className={`whitespace-nowrap ${isPureMobile && 'text-16'} ${textStyles}`}
          data-ffid={`lbl-${cleanString(ffidCurated ?? '')}-saveto-${keyProp}`}
        >
          {expiresInOrStatus ?? SAVE_TO_PROJECTS}
        </span>
      </div>
    </Link>
  );
};

export default SaveToProjectsComponent;
